import { Tab } from '../../types'

export const Tabs: Tab[] = [
  {
    id: 'licence',
    label: 'Driver Licence',
  },
  {
    id: 'covr',
    label: 'COVR',
    disabled: true,
  },
  {
    id: 'record',
    label: 'Driving Record',
    disabled: true,
  },
  {
    id: 'others',
    label: 'Others',
    disabled: true,
  },
]
